(function () {
  "use strict";
  // Reuse Klaviyo's native app loader if it is already present.
  if (document.querySelector('script[src*="static.klaviyo.com/onsite/"]')) return;
  var script = document.createElement("script");
  script.async = true;
  script.src = "https://static.klaviyo.com/onsite/js/SpM4zY/klaviyo.js";
  document.head.appendChild(script);
})();
